import * as assessments from './scoring/assessments';
import * as helpers from './helpers';
import * as markers from './markers';
import * as interpreters from './scoring/interpreters';
import * as languageProcessing from './languageProcessing';
import * as values from './values';
import * as assessors from './scoring/assessors';
import Assessor from './scoring/assessors/assessor';
import AvadaAssessor from './scoring/assessors/avadaAssessor';
import ContentAssessor from './scoring/assessors/contentAssessor';
import SeoAssessor from './scoring/assessors/seoAssessor';
import Paper from './values/Paper';
import AssessmentResult from './values/AssessmentResult';
import Assessment from './scoring/assessments/assessment';
import {DIFFICULTY} from './languageProcessing/researches/getFleschReadingScore';
import * as CONSTANT from './const/analysis'
import Researcher from './languageProcessing/languages/_default/Researcher';
import Factory from './helpers/factory';

const LOCALE_RESEARCHER_LOADERS = {
  ar: () => import('./languageProcessing/languages/ar/Researcher'),
  ca: () => import('./languageProcessing/languages/ca/Researcher'),
  cs: () => import('./languageProcessing/languages/cs/Researcher'),
  de: () => import('./languageProcessing/languages/de/Researcher'),
  el: () => import('./languageProcessing/languages/el/Researcher'),
  en: () => import('./languageProcessing/languages/en/Researcher'),
  es: () => import('./languageProcessing/languages/es/Researcher'),
  fa: () => import('./languageProcessing/languages/fa/Researcher'),
  fr: () => import('./languageProcessing/languages/fr/Researcher'),
  he: () => import('./languageProcessing/languages/he/Researcher'),
  hu: () => import('./languageProcessing/languages/hu/Researcher'),
  id: () => import('./languageProcessing/languages/id/Researcher'),
  it: () => import('./languageProcessing/languages/it/Researcher'),
  ja: () => import('./languageProcessing/languages/ja/Researcher'),
  nb: () => import('./languageProcessing/languages/nb/Researcher'),
  nl: () => import('./languageProcessing/languages/nl/Researcher'),
  pl: () => import('./languageProcessing/languages/pl/Researcher'),
  pt: () => import('./languageProcessing/languages/pt/Researcher'),
  ru: () => import('./languageProcessing/languages/ru/Researcher'),
  sk: () => import('./languageProcessing/languages/sk/Researcher'),
  sv: () => import('./languageProcessing/languages/sv/Researcher'),
  tr: () => import('./languageProcessing/languages/tr/Researcher'),
  zh: () => import('./languageProcessing/languages/zh/Researcher')
};

async function getResearcherByLocale(locale) {
  const loader = LOCALE_RESEARCHER_LOADERS[locale];
  if (loader) {
    const mod = await loader();
    return mod.default || mod;
  }
  return Researcher;
}

/*
 * Everything exported here is put on the `yoast.analysis` global in the plugin.
 */
export {
  Assessor,
  ContentAssessor,
  SeoAssessor,
  AvadaAssessor,
  Paper,
  AssessmentResult,
  Assessment,
  assessments,
  assessors,
  helpers,
  markers,
  interpreters,
  languageProcessing,
  values,
  DIFFICULTY,
  Factory,
  Researcher,
  getResearcherByLocale
};

/*
 * Used for backwards compatibility reasons.
 * For new exports, please add it as a named dependency above instead.
 */
export default {
  Assessor,
  ContentAssessor,
  SeoAssessor,
  AvadaAssessor,
  Researcher,
  getResearcherByLocale,
  Paper,
  AssessmentResult,

  assessments,
  helpers,
  markers,
  interpreters,
  languageProcessing,
  values,
  CONSTANT
};
